export default "__VITE_ASSET__BxU$KdOr__"